<template>
  <div
    v-if="!$slots.trigger"
    class="flex size-10 shrink-0 cursor-pointer items-center justify-center rounded-full hover:bg-gray-100"
    :data-test="data_test"
    @click.stop.prevent="(event) => togglePopover(event)"
  >
    <FontAwesomeIcon
      class="flex-center has-text-grey"
      :icon="['far', 'ellipsis']"
      size="lg"
    />
  </div>
  <ButtonTertiary
    v-else
    @onClick="togglePopover"
  >
    <slot name="trigger" />
  </ButtonTertiary>

  <Popover
    ref="popover"
    class="!z-[2000]"
    :pt="{ content: '!p-0 !m-0' }"
  >
    <div
      class="flex flex-col gap-1 py-2"
      @click="closePopover"
    >
      <slot />
    </div>
  </Popover>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
  loading: { type: Boolean, default: false },
  data_test: { type: String, default: 'button-dropdown-options' },
});

const popover = ref(null);

const togglePopover = (event) => {
  popover.value.toggle(event);
};

const closePopover = () => {
  popover.value.toggle(false);
};
</script>
